import React from 'react'
import Layout from '../components/Layout'
import About from '../components/About'
import Grid from '../components/Grid'
import Spacer from '../components/Spacer'
import Hobbies from '../components/Hobbies'
import Currently from '../components/Currently'

const IndexPage = () => (
  <Layout>
    <Grid>
      <About />
      <Spacer />
      <Hobbies />
      <Spacer />
      <Currently />
    </Grid>
  </Layout>
)

export default IndexPage
